module.exports = __webpack_public_path__ + "img/The waving consensus.02d4d42f.svg";